import React from "react";

import Post_Img_1 from "../../img/news/post_img_1.webp";
import Post_Img_2 from "../../img/news/post_img_2.webp";
import Post_Img_3 from "../../img/news/post_img_3.jpg";
import Post_Img_4 from "../../img/news/post_img_4.jpg";

function News() {
    const newsList = [
        {
            title: 'Наталія Лисун, Київстар: «Big Data допомагає шукати людей так само ефективно, як клієнтів»',
            img: Post_Img_2,
            link: 'https://delo.ua/business/nataliya-lisun-kiyivstar-big-data-dopomagaje-sukati-lyudei-tak-samo-efektivno-yak-klijentiv-469084/'
        },
        {
            title: 'HR Wisdom Summit 2026: як українські компанії будують бренд роботодавця, якому вірять',
            img: Post_Img_3,
            link: 'https://delo.ua/business/hr-wisdom-summit-2026-yak-ukrayinski-kompaniyi-buduyut-brend-robotodavcya-yakomu-viryat-468870/#google_vignette'
        },
        {
            title: 'Тетяна Попова, Uklon: «Культура — це актив. Її потрібно системно захищати під час змін»',
            img: Post_Img_4,
            link: 'https://delo.ua/business/tetyana-popova-uklon-kultura-ce-aktiv-yiyi-potribno-sistemno-zaxishhati-pid-cas-zmin-469055/'
        },
    ];

    return (
        <section className="mb-[60px] lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <h2 className="text-[30px] uppercase text-center font-bold xl:text-[55px] mb-10">Читати про HRWS</h2>
                <div className="grid gap-14 md:grid-cols-3 mb-12">
                    {newsList.map((item, index) => (
                        <article key={index}>
                            <div className="mb-4">
                                <img  src={item.img}  alt={item.title} className="w-full"
                                />
                            </div>

                            <h3 className="mb-4 font-bold text-xl">
                                {item.title}
                            </h3>

                            <a href={item.link}  target="_blank" rel="noopener noreferrer"
                                className="inline-block text-center text-base bg-[#37D3CA] text-black font-bold px-3 py-2 
                                    tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                                Читати більше
                            </a>
                        </article>
                    ))}
                </div>
                <div className="text-center">
                    <a href="https://delo.ua/tags/events-ekonomika/"  target="_blank" rel="noopener noreferrer"
                        className="inline-block text-center text-base bg-[#FED84A] text-black font-bold px-8 py-3 uppercase
                            tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                        Читати все
                    </a>
                </div>
            </div>
        </section>
    );
}

export default News;